import { useQuery } from '@apollo/client';
import React from 'react';
import { EVENT_PAYMENTS_WITH_WARNING } from '../../../../../apollo/query/event';
import BadResponse from '../../../../../components/BadResponse';
import { useIntl } from 'react-intl';
import { Alert } from 'antd';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import IntlMessages from '../../../../../util/IntlMessages';
import PaymentTypeIcon from '../../../../../components/Payment/PaymentTypeIcon';
import { RocketFilled } from '@ant-design/icons';

const EventPaymentsAlert = ({
    eventId,
}) => {

    const intl = useIntl();

    const { data, loading, error } = useQuery(EVENT_PAYMENTS_WITH_WARNING, {
        variables: { event_id: eventId },
    });

    if (error) {
        return <BadResponse title={intl.formatMessage({ id: '500.ooops' })} subtitle={intl.formatMessage({ id: '500.something_wrong' })} />;
    }

    if (loading) {
        return null
    }

    if (!data || !data.eventPaymentsWithWarning || data.eventPaymentsWithWarning.length === 0) {
        return null;
    }

    return (
        <Alert
            icon={<RocketFilled />}
            type='warning'
            showIcon
            message={intl.formatMessage({ id: 'payments.deleted_with_alerts' }, { count: data.eventPaymentsWithWarning.length })}
            description={(
                <div>
                    <ul className='ant-list gx-mt-3'>
                        {data.eventPaymentsWithWarning.map((payment) => (
                            <li key={payment.id} className='gx-mb-2'>
                                <Link to={`/admin/event/${eventId}/payment/view/${payment.id}`}>
                                    <IntlMessages
                                        id='common.payment'
                                    />:
                                    <span className='gx-pl-2'>{payment.payer.full_name}</span> <PaymentTypeIcon transaction={payment.transaction} />
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        />
    );
}

export default EventPaymentsAlert;